import {
  Button,
  Col,
  Form,
  Input,
  Layout,
  message,
  Modal,
  Popconfirm,
  Row,
  Tabs,
  DatePicker,
  Table,  
  Dropdown, 
  Menu,
} from "antd";
import { Eye, Pen, ChevronDown } from "lucide-react";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../../Components/Navbar/Navbar";
import PageHeader from "../../Components/PageHeader/PageHeader";
import {
  formatDate,
  formatString,
  getDateRange,
  handleChangePage,
  handlePageSizeChange,
  navigateTo,
} from "../../Utils/Common";
import CustomTable from "../../Components/Table/CustomTable";
import { getRequest, postRequest } from "../../Utils/ApiCalls";
import PersistentFooter from "../../Components/PersistentFooter/PersistentFooter";
import dayjs from "dayjs";
import { render } from "@testing-library/react";

const { RangePicker } = DatePicker;
const { TabPane } = Tabs;

const PettyCashOut = () => {
  const [loading, setLoading] = useState("");
  const [showModal, setShowModal] = useState("");
  const dateRange = getDateRange("week");
  const [filterConfig, setFilterConfig]: any = useState({
    date_from: formatDate(dateRange[0], "YYYY-MM-DD"),
    date_to: formatDate(dateRange[1], "YYYY-MM-DD"),
    page: 1,
    status: 'pending'
  });
  const [dataSize, setDataSize] = useState(0);
  const [form] = Form.useForm();
  const [selectedRow, setSelectedRow]: any = useState({});
  const [dataSource, setDataSource]: any = useState([]);
  const [activeTab, setActiveTab] = useState("pending");

  function clearFields() {
    setSelectedRow({});
    form.resetFields();
  }

  function onChangeTab(activeKey: any) {
    setActiveTab(activeKey);
    setFilterConfig((prev: any) => ({
          ...prev,
          status: activeKey
        }));
  }

  function getTableColumns() {
    switch (activeTab) {
      case "pending":
        return [
          {
            title: "Date",
            dataIndex: "date",
            key: "date",
            render: (date: any) => formatDate(date, "MMM DD, YYYY h:mm A"),
          },
          {
            title: "Branch",
            dataIndex: "branch_name",
            key: "branch_name",
          },
          {
            title: "List of Particulars",
            key: "items",
            render: (_text: any, record: any) =>
              record.items?.length ? (
                record.items.map((item: any, index: number) => (
                  <div key={item.id ?? index}>{item.item_name}</div>
                ))
              ) : (
                <span>-</span>
              ),
          },
          {
            title: "Supplier name",
            dataIndex: "supplier_name",
            key: "supplier_name",
          },
          {
            title: "Status",
            dataIndex: "status",
            key: "satus",
          },
          {
            title: "Balance",
            dataIndex: "grand_total",
            key: "grand_total",
            align: "right" as any,
          },
          // {
          //   title: "Requested By",
          //   dataIndex: "requested_by",
          //   key: "requested_by",
          // },
          {
            title: "Added By",
            dataIndex: "added_by_name",
            key: "added_by_name",
          },
          {
            title: "",
            key: "action",
            width: 10,
            align: "center" as const,
            render: (_text: any, record: any) => (
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item
                      key="edit"
                      icon={<Pen strokeWidth={1.5} size={15} />}
                      onClick={() => navigateTo(`/petty-cash/edit/${record.id}`)}
                    >
                      Edit
                    </Menu.Item>
                    <Menu.Item
                      key="view"
                      icon={<Eye strokeWidth={1.5} size={15} />}
                      onClick={() => navigateTo(`/petty-cash/view/${record.id}`)}
                    >
                      Review
                    </Menu.Item>
                  </Menu>
                }
                trigger={["click"]}
              >
                <Button>Actions <ChevronDown strokeWidth={0.5} /></Button>
              </Dropdown>
            ),
          },

        ];
      case "approved":
        return [
          {
            title: "Date",
            dataIndex: "date",
            key: "date",
          },
          {
            title: "Branch",
            dataIndex: "branch_name",
            key: "branch_name",
          },
          {
            title: "List of Particulars",
            key: "items",
            render: (_text: any, record: any) =>
              record.items?.length ? (
                record.items.map((item: any, index: number) => (
                  <div key={item.id ?? index}>{item.item_name}</div>
                ))
              ) : (
                <span>-</span>
              ),
          },
          {
            title: "Supplier name",
            dataIndex: "supplier_name",
            key: "supplier_name",
          },
          {
            title: "Status",
            dataIndex: "status",
            key: "satus",
          },
          {
            title: "Balance",
            dataIndex: "grand_total",
            key: "grand_total",
            align: "right" as any,
          },
          // {
          //   title: "Requested By",
          //   dataIndex: "requested_by",
          //   key: "requested_by",
          // },
          {
            title: "Added By",
            dataIndex: "added_by_name",
            key: "added_by_name",
          },
          {
            title: "Approved By",
            dataIndex: "approver_name",
            key: "approver_name",
          },
          {
            title: "Action",
            key: "action",
            align: "center" as const,
            render: (_text: any, record: any) => (
              <div className="flex gap-2">
                {/* View Button */}
                {/* <Button
                  type="default"
                  size="small"
                  onClick={() => navigateTo(`/petty-cash/view/${record.type}/${record.id}`)}
                >
                  View
                </Button> */}

                {/* Edit Button */}
                <Button
                  type="primary"
                  size="small"
                  onClick={() => navigateTo(`/petty-cash/view/${record.id}`)}
                >
                  View
                </Button>
              </div>
            ),
          }

        ];
      case "disapproved":
        return [
          {
            title: "Date",
            dataIndex: "date",
            key: "date",
          },
          {
            title: "Branch",
            dataIndex: "branch_name",
            key: "branch_name",
          },
          {
            title: "List of Particulars",
            key: "items",
            render: (_text: any, record: any) =>
              record.items?.length ? (
                record.items.map((item: any, index: number) => (
                  <div key={item.id ?? index}>{item.item_name}</div>
                ))
              ) : (
                <span>-</span>
              ),
          },
          {
            title: "Supplier name",
            dataIndex: "supplier_name",
            key: "supplier_name",
          },
          {
            title: "Status",
            dataIndex: "status",
            key: "satus",
          },
          {
            title: "Balance",
            dataIndex: "grand_total",
            key: "grand_total",
            align: "right" as any,
          },
          // {
          //   title: "Requested By",
          //   dataIndex: "requested_by",
          //   key: "requested_by",
          // },
          {
            title: "Added By",
            dataIndex: "added_by_name",
            key: "added_by_name",
          },
          {
            title: "Disapproved By",
            dataIndex: "disapprover_name",
            key: "disapprover_name",
          },
          {
            title: "Reason",
            dataIndex: "reason",
            key: "reason",
          },
          {
            title: "Action",
            key: "action",
            align: "center" as const,
            render: (_text: any, record: any) => (
              <div className="flex gap-2">
                {/* View Button */}
                {/* <Button
                  type="default"
                  size="small"
                  onClick={() => navigateTo(`/petty-cash/view/${record.type}/${record.id}`)}
                >
                  View
                </Button> */}

                {/* Edit Button */}
                <Button
                  type="primary"
                  size="small"
                  onClick={() => navigateTo(`/petty-cash/view/${record.id}`)}
                >
                  View
                </Button>
              </div>
            ),
          }

        ];
      default:
        return [];
    }
  }

  function handleFilterChange(value: any, field: string) {
    if (field === "dates") {
      if (!value || value.length !== 2) {
        // Clear the date filters
        setFilterConfig((prev: any) => ({
          ...prev,
          date_from: null,
          date_to: null,
        }));
        return;
      }
      setFilterConfig((prev: any) => ({
        ...prev,
        date_from: value[0]?.format("YYYY-MM-DD"), // or "YYYY-MM" if you prefer
        date_to: value[1]?.format("YYYY-MM-DD"),
      }));
    } else {
      setFilterConfig((prev: any) => ({
        ...prev,
        [field]: value,
      }));
    }
  }

  async function submitForm(data: any) {
    setLoading("submit");
    var response = await postRequest(
      `expense_types/${showModal}`,
      { expense_type_id: selectedRow.id, ...data },
      true
    );
    if (response.success) {
      message.success(formatString(response.data.message));
      setTimeout(() => {
        clearFields();
        setShowModal("");
        setLoading("");
        fetchTableData();
      }, 1000);
    } else {
      setLoading("");
      message.error(
        response?.data?.response?.data?.messages?.error_messages?.[0] ??
          `Failed to ${showModal} expense type.`
      );
    }
  }

  async function deleteExpenseType() {
    var response = await postRequest(
      `expense_types/delete`,
      {
        expense_type_id: selectedRow.id,
      },
      true
    );
    if (response.success) {
      message.success(formatString(response.data.message));
      setTimeout(() => {
        setShowModal("");
        clearFields();
        fetchTableData();
      }, 1000);
    } else {
      message.error(
        formatString(
          response?.data?.response?.data?.messages?.error_messages[0] ??
            "Failed to delete expense type."
        )
      );
    }
  }

  async function fetchTableData() {
    setDataSource([]);
    setLoading("fetch");
    var response = await getRequest(`pettycash/get`, filterConfig, true);
    if (response.success) {
      setDataSize(response.data.size);
      setDataSource(response.data.data);
    }
    setLoading("");
  }

  useEffect(() => {
    fetchTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterConfig]);

  return (
    <Layout className="page">
      <Helmet>
        <title>Agua Lab ERP System</title>
      </Helmet>
      <Navbar />
      <Layout>
        <Row className="px-3 pt-20 md:px-10 md:pb-10 md:pt-8 w-screen md:w-full pb-[50px] sm:pb-0 overflow-scroll text-textColor">
          <Col xs={24}>
            <PageHeader
              title="Petty Cash - Cash Out"
              withDateRangeFilter={false}
              withAddButton={true}
              addBtnText="Petty Cash"
              onCreate={() => navigateTo("/petty-cash/add")}
              // addDropdownBtnText="Petty Cash"
              // dropdownButton={true}
              // dropdownOptions={[
              //   { label: "Cash In", value: "cash-in" },
              //   { label: "Cash out", value: "pending" },
              // ]}
              // handleSelectChange={(value: any) => {
              //   if (value === "cash-in") {
              //     navigateTo(`/petty-cash/add/cash-in`);
              //   } else {
              //     navigateTo(`/petty-cash/add`);
              //   }
              // }}
              withSearchBtn={true}
              onSearch={(value: any) =>
                setFilterConfig((prev: any) => ({
                  ...prev,
                  search: value,
                }))
              }
            />
          </Col>
          <Col xs={24} className="mb-1">
            <span>
              <strong>Filter By:</strong>
            </span>
          </Col>
          <Col xs={24} md={12} lg={8} className="mb-3">
            <RangePicker
              value={[
                filterConfig.date_from ? dayjs(filterConfig.date_from) : null,
                filterConfig.date_to ? dayjs(filterConfig.date_to) : null,
              ]}
              format="MMMM D, YYYY" // e.g., "July 2025"
              onChange={(e) => handleFilterChange(e, "dates")}
              allowClear
              className="w-full"
            />
          </Col>
          <Col span={24}>
            {/* <div className="table-container overflow-auto">
              <div className="min-w-[800px]">
                <CustomTable
                  data={dataSource}
                  columns={columns}
                  rowKey="id"
                  loading={loading === "fetch"}
                  size="small"
                  pagination={{
                    current: filterConfig.page,
                    total: dataSize,
                    showSizeChanger: true,
                    onChange: (page: number) =>
                      handleChangePage(page, setFilterConfig),
                    onShowSizeChange: (_: number, size: number) =>
                      handlePageSizeChange(size, setFilterConfig),
                  }}
                  handleRowClick={(record: any) => {
                    setShowModal("update");
                    var data = {
                      ...record,
                    };
                    setSelectedRow(data);
                    form.setFieldsValue({ ...data });
                  }}
                />
              </div>
            </div> */}
            <div className="table-container overflow-auto">
              <div className="min-w-[800px]">
                <Tabs
                  type="card"
                  className="custom-tabs"
                  activeKey={activeTab}
                  onTabClick={onChangeTab}
                >
                  <TabPane tab="Cash Out Request" key="pending">
                    <Table
                      columns={getTableColumns()}
                      dataSource={dataSource}
                      rowKey="id"
                      loading={loading === "fetch"}
                      size="small"
                      pagination={{
                        current: filterConfig.page,
                        total: dataSize,
                        showSizeChanger: true,
                        onChange: (page: number) =>
                          handleChangePage(page, setFilterConfig),
                        onShowSizeChange: (_: number, size: number) =>
                          handlePageSizeChange(size, setFilterConfig),
                      }}
                      // rowClassName={() => "cursor-pointer"}
                      // onRow={(record: any) => ({
                      //   onClick: () => {
                      //     setSelectedRow(record);
                      //     form.setFieldsValue(record);
                      //     setShowModal("update");
                      //   },
                      // })}
                    />
                  </TabPane>
                  <TabPane tab="Approved" key="approved">
                    <Table
                      columns={getTableColumns()}
                      dataSource={dataSource}
                      rowKey="id"
                      loading={loading === "fetch"}
                      size="small"
                      pagination={{
                        current: filterConfig.page,
                        total: dataSize,
                        showSizeChanger: true,
                        onChange: (page: number) =>
                          handleChangePage(page, setFilterConfig),
                        onShowSizeChange: (_: number, size: number) =>
                          handlePageSizeChange(size, setFilterConfig),
                      }}
                      // rowClassName={() => "cursor-pointer"}
                      // onRow={(record: any) => ({
                      //   onClick: () => {
                      //     setSelectedRow(record);
                      //     form.setFieldsValue(record);
                      //     setShowModal("update");
                      //   },
                      // })}
                    />
                  </TabPane>
                  <TabPane tab="Disapproved" key="disapproved">
                    <Table
                      columns={getTableColumns()}
                      dataSource={dataSource}
                      rowKey="id"
                      loading={loading === "fetch"}
                      size="small"
                      pagination={{
                        current: filterConfig.page,
                        total: dataSize,
                        showSizeChanger: true,
                        onChange: (page: number) =>
                          handleChangePage(page, setFilterConfig),
                        onShowSizeChange: (_: number, size: number) =>
                          handlePageSizeChange(size, setFilterConfig),
                      }}
                      // rowClassName={() => "cursor-pointer"}
                      // onRow={(record: any) => ({
                      //   onClick: () => {
                      //     setSelectedRow(record);
                      //     form.setFieldsValue(record);
                      //     setShowModal("update");
                      //   },
                      // })}
                    />
                  </TabPane>
                </Tabs>
              </div>
            </div>
          </Col>
        </Row>
      </Layout>
      <Modal
        open={showModal === "create" || showModal === "update"}
        title={`${showModal === "create" ? "Add" : "Edit"} Expense Type`}
        centered
        footer={null}
        onCancel={() => {
          setShowModal("");
          clearFields();
        }}
        width={500}
        maskClosable={false}
      >
        <div className="max-h-[70vh] overflow-y-auto pr-2">
          <Form form={form} onFinish={submitForm} layout="vertical">
            <Row className="w-full ps-1" gutter={[10, 10]}>
              <Col xs={24}>
                <Form.Item
                  label="Name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "This field is required.",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col lg={24} className="flex justify-end gap-3">
                <Form.Item>
                  <Button
                    onClick={() => {
                      setShowModal("");
                      clearFields();
                    }}
                  >
                    Cancel
                  </Button>
                </Form.Item>
                {showModal === "update" && (
                  <Form.Item>
                    <Popconfirm
                      title="Are you sure you want to delete this expense type?"
                      onConfirm={() => deleteExpenseType()}
                      okText="Yes"
                    >
                      <Button danger>Delete</Button>
                    </Popconfirm>
                  </Form.Item>
                )}
                <Form.Item>
                  <Button
                    htmlType="submit"
                    type="primary"
                    loading={loading === "submit"}
                  >
                    Submit
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
      <PersistentFooter />
    </Layout>
  );
};

export default PettyCashOut;
